var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('SubHeader',{attrs:{"title":"Admin Search"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }